<div class="pmd-circle-loader" [attr.aria-label]="'COURSE.LIST.TABLE_LOADER_LABEL' | translate">
  <svg class="circular" viewBox="25 25 50 50" aria-hidden="true">
    <circle
      class="path"
      cx="50"
      cy="50"
      r="20"
      fill="none"
      stroke-width="2"
      stroke-miterlimit="10"
      aria-hidden="true"
    />
  </svg>
</div>
